export default "__VITE_ASSET__84dc2325__"